// applications
export const SET_ASSIGNED_APPLICATIONS = 'SET_ASSIGNED_APPLICATIONS'
export const SET_BOARD_ATTACHMENTS = 'SET_BOARD_ATTACHMENTS'
export const SET_VICE_ATTACHMENTS = 'SET_VICE_ATTACHMENTS'
export const SET_REAPPBOARD_ATTACHMENTS = 'SET_REAPPBOARD_ATTACHMENTS'
export const SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS = 'SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS'
export const SET_BOARD_MINUTES_ON_REAPP_ATTACHMENTS = 'SET_BOARD_MINUTES_ON_REAPP_ATTACHMENTS'
export const SET_EXAM_RESULTS_ATTACHMENTS = 'SET_EXAM_RESULTS_ATTACHMENTS'
export const SET_FINAL_GRADE_ATTACHMENTS = 'SET_FINAL_GRADE_ATTACHMENTS'
export const SET_PROPONENT_ATTACHMENTS = 'SET_PROPONENT_ATTACHMENTS'
export const SET_PRECHECKER_ATTACHMENTS = 'SET_PRECHECKER_ATTACHMENTS'
export const SET_WORKING_APPLICATION_ATTACHMENTS = 'SET_WORKING_APPLICATION_ATTACHMENTS'
export const SET_SIMILAR_ACT_ATTACHED = 'SET_SIMILAR_ACT_ATTACHED'
export const SET_WORKING_APPLICATION = 'SET_WORKING_APPLICATION'
export const SET_USERS_TO_ASSIGN = 'SET_USERS_TO_ASSIGN'
export const SET_PRESIDENT_DECISIONS = 'SET_PRESIDENT_DECISIONS'
export const SET_ACADEMIC_AREAS = 'SET_ACADEMIC_AREAS'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_MEETINGS = 'SET_MEETINGS'
export const SHOW_HIDE_APPSEARCH = 'SHOW_HIDE_APPSEARCH'
export const SHOW_HIDE_UNISEARCH = 'SHOW_HIDE_UNISEARCH'
export const SHOW_HIDE_CONSULTANTS_LIST = 'SHOW_HIDE_CONSULTANTS_LIST'
export const SHOW_HIDE_PHD_REGISTRATION = 'SHOW_HIDE_PHD_REGISTRATION'
export const SHOW_HIDE_STATS = 'SHOW_HIDE_STATS'
export const SHOW_HIDE_FOREIGN_USER_SEARCH = 'SHOW_HIDE_FOREIGN_USER_SEARCH'
export const LOAD_SEARCHED_FOREIGN_USERS = 'LOAD_SEARCHED_FOREIGN_USERS'
export const LOAD_SEARCHED_APPS = 'LOAD_SEARCHED_APPS'
export const LOAD_STATS = 'LOAD_STATS'
export const SET_FOREIGN_USER = 'SET_FOREIGN_USER'
export const SET_SEARCHED_APPLICATION = 'SET_SEARCHED_APPLICATION'
// auth
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SELECTEDROLE = 'SELECTEDROLE'
export const CHANGEDROLE = 'CHANGEDROLE'
export const UPDATEPROFILE = 'UPDATEPROFILE'
export const SET_MFA_CREDENTIALS = 'SET_MFA_CREDENTIALS'
export const CLEAR_MFA_CREDENTIALS = 'CLEAR_MFA_CREDENTIALS'
// chat
export const ADD_CHATROOM = 'ADD_CHATROOM'
export const SET_CHATROOMS = 'SET_CHATROOMS'
export const SET_EXTERNAL_CHATROOMS = 'SET_EXTERNAL_CHATROOMS'
export const SET_CHATROOM = 'SET_CHATROOM'
export const SET_EXTERNAL_CHATROOM = 'SET_EXTERNAL_CHATROOM'
export const SET_CURRENT_CHATROOM_USERS = 'SET_CURRENT_CHATROOM_USERS'
export const SET_ALL_USERS = 'SET_ALL_USERS'
export const ADD_USER_TO_CHATROOM = 'ADD_USER_TO_CHATROOM'
export const REMOVE_USER_FROM_CHATROOM = 'REMOVE_USER_FROM_CHATROOM'

export const DELETE_CHATROOM = 'DELETE_CHATROOM'
export const GET_CHATROOM = 'GET_CHATROOM'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const SAVE_AVATAR = 'SAVE_AVATAR'
// user managment
// export const MODIFY_USER = 'MODIFY_USER'
// export const MODIFY_ROLE = 'MODIFY_ROLE'
// export const CREATE_USER = 'CREATE_USER'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js